/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TaskInJobDto } from './TaskInJobDto';
import {
    TaskInJobDtoFromJSON,
    TaskInJobDtoFromJSONTyped,
    TaskInJobDtoToJSON,
} from './TaskInJobDto';

/**
 * 
 * @export
 * @interface GetUpdatedTaskItemsDto
 */
export interface GetUpdatedTaskItemsDto {
    /**
     * 
     * @type {string}
     * @memberof GetUpdatedTaskItemsDto
     */
    targetSystemId?: string;
    /**
     * 
     * @type {Array<TaskInJobDto>}
     * @memberof GetUpdatedTaskItemsDto
     */
    tasks?: Array<TaskInJobDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetUpdatedTaskItemsDto
     */
    $type?: GetUpdatedTaskItemsDtoTypeEnum;
}


/**
 * @export
 */
export const GetUpdatedTaskItemsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoGetUpdatedTaskItemsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.GetUpdatedTaskItemsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetUpdatedTaskItemsDtoTypeEnum = typeof GetUpdatedTaskItemsDtoTypeEnum[keyof typeof GetUpdatedTaskItemsDtoTypeEnum];


/**
 * Check if a given object implements the GetUpdatedTaskItemsDto interface.
 */
export function instanceOfGetUpdatedTaskItemsDto(value?: unknown): value is GetUpdatedTaskItemsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetUpdatedTaskItemsDtoTypeEnum)[0];
}

export function GetUpdatedTaskItemsDtoFromJSON(json: any): GetUpdatedTaskItemsDto {
    return GetUpdatedTaskItemsDtoFromJSONTyped(json, false);
}

export function GetUpdatedTaskItemsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUpdatedTaskItemsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetSystemId': !exists(json, 'targetSystemId') ? undefined : json['targetSystemId'],
        'tasks': !exists(json, 'tasks') ? undefined : (json['tasks'] === null ? null : (json['tasks'] as Array<any>).map(TaskInJobDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GetUpdatedTaskItemsDtoToJSON(value?: GetUpdatedTaskItemsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetSystemId': value.targetSystemId,
        'tasks': value.tasks === undefined ? undefined : (value.tasks === null ? null : (value.tasks as Array<any>).map(TaskInJobDtoToJSON)),
        '$type': value.$type,
    });
}

